import { Link } from 'react-router-dom';

export default function LandingFooter() {
  return (
    <footer className="border-t border-[var(--color-border)] bg-[var(--color-bg-card)]">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-4 py-8 text-sm sm:flex-row sm:items-center sm:px-6">
        <div className="text-[var(--color-text-secondary)]">
          © {new Date().getFullYear()} KSS. All rights reserved.
        </div>
        <nav className="flex gap-5 text-[var(--color-text-secondary)]">
          <Link to="/portal" className="hover:text-[var(--color-text-primary)]">Customer portal</Link>
          <a href="#" className="hover:text-[var(--color-text-primary)]">Privacy</a>
          <a href="#" className="hover:text-[var(--color-text-primary)]">Terms</a>
          <a href="#" className="hover:text-[var(--color-text-primary)]">Contact</a>
        </nav>
      </div>
    </footer>
  );
}
